import { render, staticRenderFns } from "./BotReplyForm.vue?vue&type=template&id=0b61afae&scoped=true&"
import script from "./BotReplyForm.vue?vue&type=script&lang=js&"
export * from "./BotReplyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61afae",
  null
  
)

export default component.exports